import React, { useEffect, useState } from "react";
import {
  useEditAssignmentMarkMutation,
  useGetAssignmentMarksQuery,
} from "../../../features/assignmentMark/assignmentMarkAPI";
import AssignmentMarkDetails from "../../../components/admin/assignmentMarks/AssignmentMarkDetails";

function AssignmentMark() {
  //Get a
  const {
    data: assignmentMarks,
    isLoading: isAssignmentMarksLoading,
    isError: isAssignmentMarksError,
  } = useGetAssignmentMarksQuery();

  //Edit Assignment Mark
  const [
    editAssignmentMark,
    { isLoading: submissionLoading, isError: submissionError },
  ] = useEditAssignmentMarkMutation();

  //handle Local State
  const [modalOpen, setModalOpen] = useState(false);
  const [assignmentData, setAssignmentData] = useState({});
  const [mark, setMark] = useState({});
  const [counts, setCounts] = useState({
    total: 0,
    pending: 0,
    published: 0,
  });

  //handle Mark Submit

  function handleMarkSubmit(event) {
    event.preventDefault();
    editAssignmentMark({
      id: Object.keys(mark)[0],
      data: { mark: Object.values(mark)[0], status: "published" },
    });
  }

  //handle Error
  useEffect(() => {
    if (submissionError) {
      alert("Couldn't submit mark! Please try again!");
    }
  }, [submissionError]);

  //handle Badges / Counts

  useEffect(() => {
    if (assignmentMarks?.length > 0) {
      const total = assignmentMarks.length;
      const pending = assignmentMarks.filter(
        (assignment) => assignment.status === "pending"
      ).length;
      const published = assignmentMarks.filter(
        (assignment) => assignment.status === "published"
      ).length;
      setCounts({ total, pending, published });
    }
  }, [assignmentMarks]);

  let content = null;
  if (isAssignmentMarksLoading)
    content = (
      <tr>
        <td colSpan={6}>Loading...</td>
      </tr>
    );
  else if (isAssignmentMarksError)
    content = (
      <tr>
        <td colSpan={6}>⚠️ Something went wrong!</td>
      </tr>
    );
  else if (assignmentMarks?.length === 0)
    content = (
      <tr>
        <td colSpan={6}>No Assignment Submitted Yet!</td>
      </tr>
    );
  else
    content = assignmentMarks?.map((assignment) => (
      <tr
        rowspan={2}
        key={assignment?.id}
        onDoubleClick={() => {
          setAssignmentData(assignment);
          setModalOpen(true);
        }}
      >
        <td
          className="table-td"
          onClick={() => {
            setAssignmentData(assignment);
            setModalOpen(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#62c1f0"
            class="bi bi-info-circle"
            viewBox="0 0 16 16"
            className="cursor-pointer"
          >
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
          </svg>
        </td>
        <td className="table-td">{assignment?.title}</td>
        <td className="table-td">
          {new Date(assignment?.createdAt)?.toLocaleString()}
        </td>
        <td className="table-td">{assignment?.student_name}</td>
        <td className="table-td">
          <a href={assignment?.repo_link} target="_blank" rel="noreferrer">
            {assignment?.repo_link?.substring(0, 50) + "..."}
          </a>
        </td>
        {assignment?.status === "pending" ? (
          <td className="table-td input-mark">
            <form onSubmit={handleMarkSubmit}>
              <input
                min={0}
                max={assignment?.totalMark}
                onError={(event) => {
                  console.log(event);
                }}
                type="number"
                value={mark[assignment?.id] || ""}
                onChange={(event) => {
                  setMark({
                    [assignment.id]: Number(event.target.value),
                  });
                }}
                style={{
                  backgroundColor:
                    (mark[assignment?.id] > assignment?.totalMark ||
                      mark[assignment?.id] < 0) &&
                    "red",
                }}
              />
              <button type="submit" disabled={submissionLoading}>
                <svg
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                  />
                </svg>
              </button>
            </form>
          </td>
        ) : (
          <td className="table-td">{assignment?.mark}</td>
        )}
      </tr>
    ));
  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-full px-5 lg:px-20">
        <div className="px-3 py-20 bg-opacity-10">
          <ul className="assignment-status">
            <li>
              Total <span>{counts.total}</span>
            </li>
            <li>
              Pending <span>{counts.pending}</span>
            </li>
            <li>
              Mark Sent <span>{counts.published}</span>
            </li>
          </ul>
          <div className="overflow-x-auto mt-4">
            {/* {submissionError && <ErrorMessage />} */}
            <table className="divide-y-1 text-base divide-gray-600 w-full">
              <thead>
                <tr>
                  <th className="table-th">Full Info</th>
                  <th className="table-th">Assignment</th>
                  <th className="table-th">Date</th>
                  <th className="table-th">Student Name</th>
                  <th className="table-th">Repo Link</th>
                  <th className="table-th">Mark</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-600/50">{content}</tbody>
            </table>
          </div>
        </div>
      </div>
      <AssignmentMarkDetails
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        data={assignmentData}
      />
    </section>
  );
}

export default AssignmentMark;
